import * as tslib_1 from "tslib";
import { OnInit, ElementRef, EventEmitter } from '@angular/core';
import { loadModules } from 'esri-loader';
var EsriMapComponent = /** @class */ (function () {
    function EsriMapComponent() {
        this.mapLoadedEvent = new EventEmitter();
        this._zoom = 10;
        this._center = [0.1278, 51.5074];
        this._basemap = 'streets';
        this._loaded = false;
    }
    Object.defineProperty(EsriMapComponent.prototype, "mapLoaded", {
        get: function () {
            return this._loaded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EsriMapComponent.prototype, "zoom", {
        get: function () {
            return this._zoom;
        },
        set: function (zoom) {
            this._zoom = zoom;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EsriMapComponent.prototype, "center", {
        get: function () {
            return this._center;
        },
        set: function (center) {
            this._center = center;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EsriMapComponent.prototype, "basemap", {
        get: function () {
            return this._basemap;
        },
        set: function (basemap) {
            this._basemap = basemap;
        },
        enumerable: true,
        configurable: true
    });
    /*
    
        var map = new EsriMap({
          basemap: "topo"
        });
    
        // Create the MapView and reference the Map in the instance
        var view = new MapView({
          container: "viewDiv",
          map: map,
          center: [-86.049, 38.485],
          zoom: 3
        });
    
    
    */
    EsriMapComponent.prototype.initializeMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, EsriMap, EsriMapView, BasemapToggle, ScaleBar, Home, Locate, Graphic, mapProperties, map, mapViewProperties, mapView, toggle, scale, locateWidget, homeWidget, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, loadModules([
                                'esri/Map',
                                'esri/views/MapView',
                                'esri/widgets/BasemapToggle',
                                'esri/widgets/ScaleBar',
                                'esri/widgets/Home',
                                'esri/widgets/Locate',
                                'esri/Graphic'
                            ])];
                    case 1:
                        _a = _b.sent(), EsriMap = _a[0], EsriMapView = _a[1], BasemapToggle = _a[2], ScaleBar = _a[3], Home = _a[4], Locate = _a[5], Graphic = _a[6];
                        mapProperties = {
                            basemap: this._basemap
                        };
                        map = new EsriMap(mapProperties);
                        mapViewProperties = {
                            container: this.mapViewEl.nativeElement,
                            center: this._center,
                            zoom: this._zoom,
                            map: map
                        };
                        mapView = new EsriMapView(mapViewProperties);
                        toggle = new BasemapToggle({
                            view: mapView,
                            nextBasemap: "streets"
                        });
                        mapView.ui.add(toggle, "top-right");
                        scale = new ScaleBar({ view: mapView });
                        mapView.ui.add(scale, { position: "bottom-left" });
                        locateWidget = new Locate({
                            viewModel: {
                                view: mapView,
                                graphic: new Graphic({ symbol: { type: "simple-marker" } })
                            }
                        });
                        mapView.ui.add(locateWidget, "top-left");
                        homeWidget = new Home({ view: mapView });
                        mapView.ui.add(homeWidget, "top-left");
                        return [2 /*return*/, mapView];
                    case 2:
                        error_1 = _b.sent();
                        console.log('EsriLoader: ', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Finalize a few things once the MapView has been loaded
    EsriMapComponent.prototype.houseKeeping = function (mapView) {
        var _this = this;
        mapView.when(function () {
            console.log('mapView ready: ', mapView.ready);
            _this._loaded = mapView.ready;
            _this.mapLoadedEvent.emit(true);
        });
    };
    EsriMapComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Initialize MapView and return an instance of MapView
        this.initializeMap().then(function (mapView) {
            _this.houseKeeping(mapView);
        });
    };
    return EsriMapComponent;
}());
export { EsriMapComponent };
